// Shared bottom tab bar for every mobile app shell (Manager/Employee/HR —
// PO direction, 2026-07-30: "minimum chrome, navigation at the bottom").
// Previously hand-rolled identically three times (ManagerMobileTabBar,
// PortalMobileTabBar, HrMobileTabBar) differing only in the tabs array and
// `aria-label` — this is the one implementation; each surface's shell now
// just supplies its own `tabs`.

import type { ReactNode } from 'react';
import { NavLink } from 'react-router';

export interface MobileTab {
  to: string;
  label: string;
  icon: ReactNode;
  /** Passed straight to `NavLink`'s `end` — `true` for a tab whose path is
   * a prefix of a sibling tab's path (e.g. the shell's index route). */
  end?: boolean;
}

export function MobileTabBar({ ariaLabel, tabs }: { ariaLabel: string; tabs: MobileTab[] }) {
  return (
    <nav
      aria-label={ariaLabel}
      className="shrink-0 border-t border-border bg-card"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="mx-auto flex max-w-md">
        {tabs.map((tab) => (
          <li key={tab.to} className="flex-1">
            <NavLink
              to={tab.to}
              end={tab.end ?? false}
              className={({ isActive }) =>
                [
                  'flex flex-col items-center gap-0.5 py-2 text-[0.65rem] font-medium transition',
                  isActive ? 'text-primary' : 'text-muted-foreground',
                ].join(' ')
              }
            >
              {tab.icon}
              <span>{tab.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
